import React from 'react'
import OffLine from '../off-line'

const OffLineFr = () => {
    return <OffLine languageCode="fr" />
}

export default OffLineFr
